<template>
  <fragment>
    <hero-header page-name="" hero-title="Munkalapjaim"/>
    <v-container class="my-10">
      <v-row class="my-10">
        //
      </v-row>
    </v-container>
  </fragment>
</template>

<script>
import heroHeader from '../components/heroHeader.vue';
import { APIGET } from '../utils/apiHelper';

export default {
  name: 'worksheets',
  components: {
    heroHeader,
  },
  data() {
    return {
      foo: 'bar',
    };
  },
  methods: {
    async listAllAppointments() {
      try {
        const response = await APIGET('services/Event/ListFreeEventAppointments/1/hu');
        if (response) {
          // es
        } else {
          // es
        }
      } catch (err) {
        // es
      }
    },
  },
};
</script>

<style scoped>

</style>
